var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workouts_challenge"},[_vm._v(" 1 set of each exercise = excellent results! Do 2 or 3 sets if you would like the extra challenge. ")])}
var staticRenderFns = []

export { render, staticRenderFns }